import type { User } from '../lib/flotiq-client/types/api-response';
import type { UserLocalStorage } from '../types/localStorage';

import { createContext } from 'react';

import { RolePermissions } from '../lib/rolePermissions';

export interface UserContextProps {
  permissions: RolePermissions;
  isAdmin: boolean;
  isRoleAdmin: boolean;
  baseUserEventData?: Record<string, any>;
  userData?: User | null;
  userStorage?: UserLocalStorage;
}

export const UserContext = createContext<UserContextProps>({
  permissions: new RolePermissions([]),
  isAdmin: false,
  isRoleAdmin: false,
});

export default UserContext;
